module.exports = __webpack_public_path__ + "img/30-day.94b25bd4.png";